import { Tag } from '@factorialco/deprecated-design-system'

import { statusTagColor } from 'modules/banking/lib/cards/statusTagColor'
import { statusText } from 'modules/banking/lib/cards/statusText'
import { CardWithStatus } from 'modules/banking/lib/cards/types'

export const CardStatusTag: React.FC<{ card: CardWithStatus; showCircle?: boolean }> = ({
  card,
  showCircle = true,
}) => {
  const color = statusTagColor(card)
  const text = statusText(card)

  return (
    <Tag type={color} leftItem="circle" showCircle={showCircle}>
      {text}
    </Tag>
  )
}
